import { Menu } from 'antd';
import { useLocation } from 'react-router-dom';
import useSidebarMenuItems from './useSidebarMenuItems';
import { SidebarMenuProps } from './types';

// Sidebar menu component
function SidebarMenu({ onClose }: SidebarMenuProps) {
  const { pathname } = useLocation();
  const items = useSidebarMenuItems();

  return (
    <Menu
      mode='inline'
      inlineIndent={0}
      items={items}
      defaultSelectedKeys={[pathname]}
      selectedKeys={[pathname]}
      onClick={onClose}
    />
  );
}

export default SidebarMenu;
